$(function () {
    /**
     * Fastclick
     */
    FastClick.attach(document.body);

    /**
     * FitVids
     */
    $('.Grid').fitVids();

    /**
     * Open / close Submavigation on non-mobile devices
     */
    $('.Navigation a').on('click', function (event) {
        var subnav = $('.Header nav > .Subnavigation[data-parent=' + $(this).data('id') + ']');

        if (subnav.length) {
            event.preventDefault();

            if ($('.Header .mobile').hasClass('open')) {
                return;
            }

            if (subnav.hasClass('open')) {
                subnav
                    .slideUp(150)
                    .removeClass('open')
                    .children('*').fadeOut(100);
                return;
            }

            var timer = 1;
            if ($('.Header nav > .Subnavigation.open').length) {
                $('.Header nav > .Subnavigation.open')
                    .slideUp(150)
                    .removeClass('open')
                    .children('*').fadeOut(100);
                timer = 150;
            }

            setTimeout(function () {
                subnav
                    .slideDown(300)
                    .addClass('open')
                    .children('*').fadeOut(0);
                setTimeout(function () {
                    subnav.children('*').fadeIn(300);
                }, 150);
            }, timer);
        }
    });

    /**
     * Open / close menu on mobile devices
     */
    $('.btn-menu, .btn-close', '.Header .mobile').on('click', function () {
        $('.Header .mobile').toggleClass('open');
    });

    /**
     * Scrool top
     */
    $('.Footer .back-to-top img').on('click', function () {
        $('html, body').animate({scrollTop: 0});
    });

    /**
     * Grid scroll animation
     */
    $('.Grid__row, .Flickity').waypoint({
        handler: function (direction) {
            if ($(this.element).hasClass('Flickity')) {
                var element = $(this.element);
                setTimeout(function () {
                    element.animate({
                        opacity: 1,
                        top: 0
                    }, 700);
                }, i++ * 150);
            }

            var i = 0;
            $(this.element).find('.Grid__row__col').each(function () {
                var element = $(this);
                setTimeout(function () {
                    element.animate({
                        opacity: 1,
                        top: 0
                    }, 700);
                }, i++ * 150);
            });
        },
        offset: '75%'
    });

    /**
     * lightbox options
     */
    lightbox.option({
        disableScrolling: true
    });

    /**
     * Flickity
     */
    $('.Flickity').flickity({
        cellSelector: '.Flickity__item',
        cellAlign: 'left',
        contain: true,
        pageDots: false,
        setGallerySize: false
    });

    /**
     * jQuery placeholder
     */
    $('input, textarea').placeholder();

    /**
     * Homepage Phase 2 modal window
     */
    $('#phase2-modal-trigger').fancybox({
        wrapCSS: 'phase2-modal',
        //padding: [60, 45, 60, 45],
        padding: [0, 0, 0, 0],
        autoHeight: true,
        scrolling: 'no',
        maxWidth: '100%',
        fitToView: false,
        autoPlay: false,
        loop: false,
        type: 'inline',
        helpers: {
            overlay: {
                showEarly: true,
                css: {
                    background: 'rgba(255,255,255,0.75)'
                }
            }
        }
    });
    $('#phase2-modal-trigger').trigger('click');

    /**
     * Homepage Available Units modal window
     */
    $('#available-units-modal-trigger').fancybox({
        wrapCSS: 'available-units-modal',
        padding: [50, 45, 40, 45],
        autoHeight: true,
        scrolling: 'no',
        minWidth: '100%',
        maxWidth: 600,
        fitToView: true,
        autoPlay: false,
        loop: false,
        type: 'inline',
        helpers: {
            overlay: {
                showEarly: true,
                css: {
                    background: 'rgba(255,255,255,0.75)'
                }
            }
        }
    });
    $('#available-units-modal-trigger').trigger('click');

    /**
     * Homepage Spaces for rent modal window
     */
    $('#spaces-for-rent-modal-trigger').fancybox({
        wrapCSS: 'spaces-for-rent-modal',
        padding: [30, 40, 30, 40],
        autoHeight: true,
        scrolling: 'auto',
        minWidth: '100%',
        maxWidth: 600,
        fitToView: true,
        autoPlay: false,
        loop: false,
        type: 'inline',
        helpers: {
            overlay: {
                showEarly: true,
                css: {
                    background: 'rgba(255,255,255,0.75)'
                }
            }
        }
    });
    $('#spaces-for-rent-modal-trigger').trigger('click');

    /**
     * Image gallery
     */
    var $gallery = $('.gallery-grid').isotope({
        itemSelector: '.grid-item',
        percentPosition: true,
        masonry: {
            columnWidth: '.grid-sizer',
        }
    });
    // layout Isotope after each image loads
    $gallery.imagesLoaded().progress( function() {
        $gallery.isotope('layout');
    });
    // fancybox
    $('.gallery-grid .fancybox').fancybox({
        padding : 0,
        helpers : {
            overlay : {
                css : {
                    'background' : 'rgba(0,0,49,0.8)'
                }
            }
        },
        nextEffect: 'fade',
        prevEffect: 'fade'
    });
});


// WEBPACK FOOTER //
// ./public/js/all.js